module.exports = __webpack_public_path__ + "static/media/iot-logo.09397f4d.svg";